export default __webpack_public_path__ + "static/media/icon-small-bold-close.7fea02c1.svg";